// extracted by mini-css-extract-plugin
module.exports = {"blue":"#2E3F8C","lightBlue":"#4E9FFB","grey":"#E6E6E6","white":"#FFFFFF"};